import type { FunctionComponent } from "react";
import { JsonLd } from "react-schemaorg";
import type { WebPage } from "schema-dts";

type Props = Record<string, never>;

export const GamePageSchema: FunctionComponent<Props> = () => (
  <JsonLd<WebPage>
    item={{
      "@context": "https://schema.org",
      "@type": "WebPage",
      about: {
        "@type": "Thing",
        name: "Games",
      },
      description: "Discover our collection of puzzle and word games.",
      name: "SCMP Games",
    }}
  />
);

GamePageSchema.displayName = "GamePageSchema";
